import React, { useEffect, useState } from "react";
import "../styles/inquiry.css";
import PageHeader from "../../../../components/common/PageHeader";
import { getClientById, getClientContacts, getClientList } from "../../../client/api/clientService";
import { getPLList, getChannelList, getResponsibleUsers, getInquirySourceList, createInquiry, uploadInquiryDocuments, getStageListForInquiry, getClientSegmentByVertical } from "../api/inquiry.api";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getStageList } from "../../../stage";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { VERTICALS } from "../../../../constants/verticals";

/* ===== react-select styled to work with Bootstrap form-floating ===== */


const InquiryCreate = () => {
    const navigate = useNavigate();

    const [createdInquiryId, setCreatedInquiryId] = useState<number | null>(null);
    const { vertical } = useParams<{ vertical: string }>();

    const verticalConfig = VERTICALS.find(v => v.key === vertical);

    const verticalId = verticalConfig?.id;
    const verticalName = verticalConfig?.label;

    const [isValidVertical, setIsValidVertical] = useState(true);

    useEffect(() => {
        if (!verticalId || !verticalName) {
            toast.error("Invalid vertical");
            navigate("/dashboard", { replace: true });
            setIsValidVertical(false);
        }
    }, [verticalId, verticalName, navigate]);

    const isLixil = Number(verticalId) === 3;

    /* ================= CLIENT ================= */
    const [clientOptions, setClientOptions] = useState<any[]>([]);
    const [selectedClient, setSelectedClient] = useState<any>(null);
    const [segmentOptions, setSegmentOptions] = useState<any[]>([]);
    const [selectedSegment, setSelectedSegment] = useState<any>(null);
    const [contactOptions, setContactOptions] = useState<any[]>([]);
    const [selectedContact, setSelectedContact] = useState<any>(null);
    const [stageOptions, setStageOptions] = useState<any[]>([]);
    const [stagePage, setStagePage] = useState(1);
    const [hasMoreStages, setHasMoreStages] = useState(true);
    const [loadingStages, setLoadingStages] = useState(false);

    const [responsibleOptions, setResponsibleOptions] = useState<any[]>([]);
    const [sourceOptions, setSourceOptions] = useState<any[]>([]);
    const [errors, setErrors] = useState<Record<string, string>>({});

    /* ================= PROJECT ================= */
    const [plOptions, setPlOptions] = useState<any[]>([]);
    const [channelOptions, setChannelOptions] = useState<any[]>([]);
    const [channelPage, setChannelPage] = useState(1);
    const [hasMoreChannels, setHasMoreChannels] = useState(true);
    const [loadingChannels, setLoadingChannels] = useState(false);
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // yyyy-mm-dd
    };
    const [projectDetails, setProjectDetails] = useState({
        projectName: "",
        pl: null as any,
        architectName: "",
        facadeConsultant: "",
        channel: null as any,
        state: "",
        city: "",
        area: "",
        pincode: "",
        expectedClosing: "",
        documents: [] as {
            file: File;
            description: string;
            progress: number;
            isEditing: boolean;

        }[],
        inquirySource: null as any,
        inquiryStage: null as any,
        responsiblePerson: null as any,
        assignTo: null as any,
        inquiryReceivedDate: getTodayDate(),
        specialNote: "",
    });

    const [clientPage, setClientPage] = useState(1);
const [hasMoreClients, setHasMoreClients] = useState(true);
const [loadingClients, setLoadingClients] = useState(false);
    useEffect(() => {
        if (!verticalId) return;

        getClientSegmentByVertical(verticalId)
            .then((res) => {
                setSegmentOptions(
                    res.data.results.map((s: any) => ({
                        value: s.id,
                        label: s.name, // no need to show vertical name now
                    }))
                );
            })
            .catch(() => {
                toast.error("Failed to load client segments");
            });
    }, [verticalId]);


    const validateForm = () => {
        const newErrors: Record<string, string> = {};

        // Client
        if (!selectedClient) {
            newErrors.client = "Client Organization Name is required";
        }

        if (!selectedContact) {
            newErrors.contact = "Contact Details are required";
        }
        if (!selectedSegment) {
            newErrors.segment = "Client Segment is required";
        }

        // Project


        if (!isLixil && !projectDetails.projectName.trim()) {
            newErrors.projectName = "Project Name is required";
        }


        if (!projectDetails.pl) {
            newErrors.pl = "PL is required";
        }

        if (!projectDetails.architectName.trim()) {
            newErrors.architectName = "Client Architect Name is required";
        }

        if (!isLixil && !projectDetails.facadeConsultant.trim()) {
            newErrors.facadeConsultant = "Facade Consultant is required";
        }

        if (!projectDetails.channel) {
            newErrors.channel = "Channel is required";
        }

        if (!projectDetails.state.trim()) {
            newErrors.state = "State is required";
        }

        if (!projectDetails.city.trim()) {
            newErrors.city = "City is required";
        }

        if (!projectDetails.area.trim()) {
            newErrors.area = "Area is required";
        }

        if (!projectDetails.pincode.trim()) {
            newErrors.pincode = "Pincode is required";
        } else if (!/^\d{6}$/.test(projectDetails.pincode)) {
            newErrors.pincode = "Pincode must be 6 digits";
        }

        if (!projectDetails.expectedClosing) {
            newErrors.expectedClosing = "Expected Closing Forecast Month is required";
        }

        if (!projectDetails.inquirySource) {
            newErrors.inquirySource = "Inquiry Source is required";
        }

        // Other Details
        if (!projectDetails.inquiryStage) {
            newErrors.inquiryStage = "Inquiry Stage is required";
        }

        if (!projectDetails.responsiblePerson) {
            newErrors.responsiblePerson = "Responsible Person is required";
        }

        if (!projectDetails.assignTo) {
            newErrors.assignTo = "Assign To is required";
        }

        if (!projectDetails.inquiryReceivedDate) {
            newErrors.inquiryReceivedDate = "Inquiry Received Date is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (!verticalId) return;

        fetchClients(1);
        fetchPL();
        fetchStages(1);
        // fetchChannels();
        fetchResponsibleUsers();
        fetchInquirySources();
    }, [verticalId]);
    useEffect(() => {
        fetchChannels(1);
    }, []);



    /* ================= CLIENT API ================= */
    const fetchClients = async (page = 1) => {

    if (loadingClients) return;
    if (page !== 1 && !hasMoreClients) return;

    try {

        setLoadingClients(true);

        const res = await getClientList(page, {});
        const results = res.data.results || [];

        const mapped = results.map((c: any) => ({
            label: c.name,
            value: c.id,
            segmentName: c.client_segment_name,
        }));

        setClientOptions(prev =>
            page === 1
                ? mapped
                : Array.from(
                    new Map(
                        [...prev, ...mapped].map(i => [i.value, i])
                    ).values()
                )
        );

        setHasMoreClients(Boolean(res.data.next));
        setClientPage(page);

    } catch (err) {

        toast.error("Failed to load clients");

    } finally {

        setLoadingClients(false);
    }
};

    const fetchStages = async (page = 1) => {
        if (loadingStages) return;

        try {
            setLoadingStages(true);

            const res = await getStageListForInquiry({ page });
            const results = res.data.results || [];

            const mapped: { label: string; value: number; isNew: boolean }[] = results
                .filter((s: any) => s.is_active)
                .map((s: any) => ({
                    label: s.stage_name,
                    value: s.id,
                    isNew: s.stage_name.toLowerCase() === "new"
                }));


            setStageOptions(prev =>
                page === 1
                    ? mapped
                    : Array.from(
                        new Map([...prev, ...mapped].map(i => [i.value, i])).values()
                    )
            );
            const newStage = mapped.find(s => s.isNew);
            if (newStage) {
                setProjectDetails(prev => ({
                    ...prev,
                    inquiryStage: newStage,
                }));
            }

            // ✅ KEY FIX: infer pagination from result size
            setHasMoreStages(results.length > 0);
            setStagePage(page);
        } catch (err) {
            console.error("Failed to fetch stages", err);
            toast.error("Failed to load stages");
        } finally {
            setLoadingStages(false);
        }
    };





    const fetchResponsibleUsers = async (stageId?: number) => {
        if (!verticalId) return;

        const res = await getResponsibleUsers({
            vertical_id: verticalId,
            stage_id: stageId,
            exclude_role: "Pre Sales",
        });

        setResponsibleOptions(
            res.data.data.map((u: any) => ({
                label: u.name,
                value: u.id,
            }))
        );
    };
    useEffect(() => {
        if (projectDetails.inquiryStage?.value) {
            fetchResponsibleUsers(projectDetails.inquiryStage.value);
        }
    }, [projectDetails.inquiryStage]);

    const fetchInquirySources = async () => {
        const res = await getInquirySourceList();
        setSourceOptions(
            res.data.results
                .filter((s: any) => s.is_active === "active")
                .map((s: any) => ({
                    label: s.name,
                    value: s.id,
                }))
        );
    };


    const handleSelectClientContact = async (option: any) => {
        setSelectedClient(option);
        setSelectedContact(null);
        setContactOptions([]);

        if (!option?.value) return;

        // Client Segment
        // if (option.segmentName) {
        //     setClientSegment(option.segmentName);
        // } else {
        //     const res = await getClientById(option.value);
        //     setClientSegment(res.data.client_segment_name || "");
        // }

        // Contact Details
        const contactRes = await getClientContacts(option.value);

        // ✅ show only is_master === true
        const contacts = contactRes.data.results
            .filter((c: any) => c.is_master === true)
            .map((c: any) => ({
                label: c.name,
                value: c.id,
                phone: c.mobile_no,
                email: c.email,
            }));

        setContactOptions(contacts);

        // ✅ auto-select if only one master contact
        if (contacts.length === 1) {
            setSelectedContact(contacts[0]);
        }
    };





    /* ================= PROJECT API ================= */
    const fetchPL = async () => {
        if (!verticalId) return;

        const res = await getPLList(verticalId);
        setPlOptions(
            res.data.results.map((pl: any) => ({
                label: pl.name,
                value: pl.id,
            }))
        );
    };



    const fetchChannels = async (page = 1) => {
        if (loadingChannels || !hasMoreChannels) return;

        setLoadingChannels(true);

        const res = await getChannelList({ page });

        setChannelOptions(prev => {
            const newOptions = res.data.results.map((c: any) => ({
                label: c.name,
                value: c.id,
            }));

            // ✅ prevent duplicates
            const merged = [...prev, ...newOptions];
            const unique = Array.from(
                new Map(merged.map(item => [item.value, item])).values()
            );

            return unique;
        });

        setHasMoreChannels(!!res.data.next);
        setChannelPage(page + 1);
        setLoadingChannels(false);
    };



    /* ================= HANDLERS ================= */
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setProjectDetails(prev => ({ ...prev, [name]: value }));

        // clear error on change
        setErrors(prev => ({
            ...prev,
            [name]: "",
        }));
    };


    const handleSelectChange = (name: string, option: any) => {
        setProjectDetails(prev => ({ ...prev, [name]: option }));
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files) return;

        const newDocs = Array.from(files).map(file => ({
            file,
            description: "",
            progress: 0,
            isEditing: true, // 👈 NEW
        }));
        setProjectDetails(prev => ({
            ...prev,
            documents: [...prev.documents, ...newDocs],
        }));

        // Fake progress animation (Taiga-like)
        newDocs.forEach((_, index) => {
            let p = 0;
            const interval = setInterval(() => {
                p += 20;
                setProjectDetails(prev => {
                    const docs = [...prev.documents];
                    const docIndex = prev.documents.length - newDocs.length + index;
                    if (docs[docIndex]) docs[docIndex].progress = Math.min(p, 100);
                    return { ...prev, documents: docs };
                });
                if (p >= 100) clearInterval(interval);
            }, 150);
        });
    };



    const handleCreateInquiry = async () => {
        if (!validateForm()) {
            toast.error("Please fix the highlighted errors");
            return;
        }
        try {

            let inquiryId = createdInquiryId; // ⭐ reuse if exists

            // ⭐ CREATE INQUIRY ONLY ONCE
            if (!inquiryId) {

                const formData = new FormData();

                formData.append("company", "2");
                formData.append("vertical", String(verticalId));

                if (selectedClient?.value)
                    formData.append("customer_id", selectedClient.value);

                if (selectedContact?.value)
                    formData.append("contact_person_id", selectedContact.value);

                if (selectedSegment?.value)
                    formData.append("client_segment", selectedSegment.value);

                // enquiry title
                if (!isLixil) {
                    formData.append("enquiry_title", projectDetails.projectName);
                }

                if (projectDetails.pl?.value)
                    formData.append("platform", projectDetails.pl.value);

                formData.append("architect_name", projectDetails.architectName);
                // facade consultant
                if (!isLixil) {
                    formData.append("facade_consultant", projectDetails.facadeConsultant);
                }

                if (projectDetails.channel?.value)
                    formData.append("channel", projectDetails.channel.value);

                formData.append("state", projectDetails.state);
                formData.append("city", projectDetails.city);
                formData.append("area", projectDetails.area);
                formData.append("pincode", projectDetails.pincode);
                formData.append("is_active", "True");

                if (projectDetails.expectedClosing) {
                    formData.append(
                        "expected_closing_date",
                        `${projectDetails.expectedClosing}-01`
                    );
                }

                if (projectDetails.inquirySource?.value)
                    formData.append("source", projectDetails.inquirySource.value);

                if (projectDetails.inquiryStage?.value)
                    formData.append("enquiry_stage", projectDetails.inquiryStage.value);

                if (projectDetails.responsiblePerson?.value)
                    formData.append("inquiry_owner", projectDetails.responsiblePerson.value);

                if (projectDetails.assignTo?.value)
                    formData.append("inquiry_assigned_to", projectDetails.assignTo.value);

                if (projectDetails.inquiryReceivedDate)
                    formData.append(
                        "inquiry_received_date",
                        new Date(projectDetails.inquiryReceivedDate).toISOString()
                    );

                formData.append("remark", projectDetails.specialNote);

                // ⭐ CREATE
                const res = await createInquiry(formData);
                inquiryId = res.data.data.id;
                setCreatedInquiryId(inquiryId);

                // Show upload message ONLY if documents exist
                if (projectDetails.documents.length > 0) {
                    toast.info("Inquiry created. Uploading documents…");
                }

            }

            let documentsUploaded = false;

            if (inquiryId && projectDetails.documents.length > 0) {
                await uploadInquiryDocuments(
                    inquiryId,
                    projectDetails.documents.map(d => ({
                        file: d.file,
                        description: d.description || "",
                    }))
                );
                documentsUploaded = true;
            }

            if (documentsUploaded) {
                toast.success("Inquiry and documents uploaded successfully");
            } else {
                toast.success("Inquiry created successfully");
            }
            navigate(`/${vertical}/inquiries`);

        } catch (error: any) {
            const apiErrors = error?.response?.data;

            if (apiErrors) {
                setErrors((prev) => ({
                    ...prev,
                    inquiryReceivedDate: apiErrors.inquiry_received_date?.[0],
                }));
            }
            const apiMessage =
                error?.response?.data?.message ||
                error?.response?.data?.detail ||
                "Failed to create inquiry";


            toast.error(apiMessage);

        }

    };
    const confirmRemoveAttachment = async (
        index: number,
        fileName: string
    ) => {
        const result = await Swal.fire({
            title: "Remove attachment?",
            html: `Are you sure you want to remove <b>${fileName}</b>?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, remove",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            reverseButtons: true,
            focusCancel: true,
        });

        if (!result.isConfirmed) return;

        setProjectDetails(prev => ({
            ...prev,
            documents: prev.documents.filter((_, i) => i !== index),
        }));

        Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Attachment removed",
            showConfirmButton: false,
            timer: 2000,
        });
    };

    const getCurrentMonth = () => {
        const today = new Date();
        return today.toISOString().slice(0, 7); // yyyy-mm
    };

    return (
        <>
            <PageHeader
                title={`Create ${verticalName ?? ""} Inquiry`}
                breadcrumbs={[
                    { label: "Sales" },
                    { label: verticalName ?? "Inquiry" },
                    { label: "Create Inquiry" },
                ]}
            />


            <div className="container-fluid mt-3">
                <div className="lixil-inquiry-card">

                    {/* ================= CLIENT DETAILS ================= */}
                    <div className="section-header">Client Details</div>

                    <div className="row g-3 align-items-start">
                        {/* Client Name – EXACT ClientForm style */}
                        <div className="col-md-4 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Client Organization Name <span className="text-danger">*</span>
                                </label>
                                <div className="d-flex gap-2">
                                    <div className="flex-grow-1">
                                        <Select
                                        onMenuScrollToBottom={() => {
        if (hasMoreClients && !loadingClients) {
            fetchClients(clientPage + 1);
        }
    }}
                                            options={clientOptions}
                                            value={
                                                clientOptions.find(opt => opt.value === selectedClient?.value) || null
                                            }
                                            onChange={(selected) => handleSelectClientContact(selected)}
                                            placeholder="Client Name *"
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        title="Create Client"
                                        onClick={() => navigate("/masters/client/create")}
                                    >
                                        <i className="fas fa-user-plus"></i>
                                    </button>

                                </div>
                                {errors.client && (
                                    <div className="text-danger small">{errors.client}</div>
                                )}
                            </div>
                        </div>



                        <div className="col-md-4 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Contact Details *
                                </label>
                                <Select
                                    options={contactOptions}
                                    value={selectedContact}
                                    onChange={(selected) => setSelectedContact(selected)}
                                    placeholder={selectedClient ? "Select Contact" : "Select Client First"}
                                    isDisabled={!selectedClient}
                                    classNamePrefix="react-select"
                                />
                                {errors.contact && (
                                    <div className="text-danger small">{errors.contact}</div>
                                )}
                            </div>
                        </div>


                        <div className="col-md-4 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Client Segment <span className="text-danger">*</span>
                                </label>
                                <Select
                                    options={segmentOptions}
                                    value={selectedSegment}
                                    onChange={(selected) => setSelectedSegment(selected)}
                                    placeholder="Select Client Segment *"
                                    classNamePrefix="react-select"
                                />
                                {errors.segment && (
                                    <div className="text-danger small">{errors.segment}</div>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* ================= PROJECT DETAILS ================= */}
                    <div className="section-header mt-4">Project Details</div>

                    <div className="row g-3 align-items-start">
                        {!isLixil && (
                            <div className="col-md-3">
                                <label className="form-label fw-semibold my-3">
                                    Project Name *
                                </label>
                                <div className="form-floating">
                                    <input
                                        className="form-control"
                                        name="projectName"
                                        value={projectDetails.projectName}
                                        onChange={handleInputChange}
                                        placeholder="Project Name *"
                                    />
                                    <label>Project Name *</label>
                                    {errors.projectName && (
                                        <div className="text-danger small">{errors.projectName}</div>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    PL <span className="text-danger">*</span>
                                </label>
                                <Select
                                    options={plOptions}
                                    value={
                                        plOptions.find(opt => opt.value === projectDetails.pl?.value) || null
                                    }
                                    onChange={(selected) =>
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            pl: selected || null,
                                        }))
                                    }
                                    placeholder="PL"
                                    classNamePrefix="react-select"
                                />
                                {errors.pl && <div className="text-danger small">{errors.pl}</div>}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                Client Architect Name *
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="architectName"
                                    value={projectDetails.architectName}
                                    onChange={handleInputChange}
                                    placeholder="Client Architect Name *"
                                />
                                <label>Client Architect Name *</label>
                                {errors.architectName && (
                                    <div className="text-danger small">{errors.architectName}</div>
                                )}

                            </div>
                        </div>
                        {!isLixil && (

                            <div className="col-md-3">
                                <label className="form-label fw-semibold my-3">
                                    Facade Consultant *
                                </label>
                                <div className="form-floating">
                                    <input
                                        className="form-control"
                                        name="facadeConsultant"
                                        value={projectDetails.facadeConsultant}
                                        onChange={handleInputChange}
                                        placeholder="Facade Consultant *"
                                    />
                                    <label>Facade Consultant *</label>
                                    {errors.facadeConsultant && (
                                        <div className="text-danger small">{errors.facadeConsultant}</div>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Channel <span className="text-danger">*</span>
                                </label>
                                <Select
                                    options={channelOptions}
                                    value={
                                        channelOptions.find(
                                            opt => opt.value === projectDetails.channel?.value
                                        ) || null
                                    }
                                    onChange={(selected) => {
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            channel: selected || null,
                                        }));
                                        setErrors(prev => ({ ...prev, channel: "" }));
                                    }}

                                    isLoading={loadingChannels}
                                    placeholder="Channel"
                                    classNamePrefix="react-select"
                                />

                                {errors.channel && (
                                    <div className="text-danger small">{errors.channel}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                Expected Closing Forecast Month *
                            </label>
                            <div className="form-floating">
                                <input
                                    type="month"
                                    className="form-control"
                                    name="expectedClosing"
                                    value={projectDetails.expectedClosing}
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => e.preventDefault()}   // ❌ block manual typing
                                    placeholder="Expected Closing *"
                                    min={getCurrentMonth()}   // ✅ prevents past months
                                />
                                <label>Expected Closing Forecast Month *</label>
                                {errors.expectedClosing && (
                                    <div className="text-danger small">{errors.expectedClosing}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                State *
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="state"
                                    value={projectDetails.state}
                                    onChange={handleInputChange}
                                    placeholder="State *"
                                />
                                <label>State *</label>
                                {errors.state && (
                                    <div className="text-danger small">{errors.state}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                City *
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="city"
                                    value={projectDetails.city}
                                    onChange={handleInputChange}
                                    placeholder="City *"
                                />
                                <label>City *</label>
                                {errors.city && (
                                    <div className="text-danger small">{errors.city}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                Area *
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="area"
                                    value={projectDetails.area}
                                    onChange={handleInputChange}
                                    placeholder="Area *"
                                />
                                <label>Area *</label>
                                {errors.area && (
                                    <div className="text-danger small">{errors.area}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                Pincode *
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="pincode"
                                    value={projectDetails.pincode}
                                    onChange={handleInputChange}
                                    placeholder="Pincode *"
                                />
                                <label>Pincode *</label>
                                {errors.pincode && (
                                    <div className="text-danger small">{errors.pincode}</div>
                                )}
                            </div>
                        </div>



                    </div>
                    <div className="section-header mt-4">Upload Documents</div>

                    <div className="taiga-attachments mt-4">
                        <div className="taiga-attachments-header">
                            <span className="fw-semibold">
                                {projectDetails.documents.length} Attachments
                            </span>
                            <label className="btn btn-taiga-add btn-primary">

                                <i className="fas fa-plus"></i>
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={handleFileChange}
                                />
                            </label>
                        </div>

                        <div
                            className="taiga-dropzone"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                                e.preventDefault();
                                const files = e.dataTransfer.files;
                                if (!files) return;

                                const droppedDocs = Array.from(files).map(file => ({
                                    file,
                                    description: "",
                                    progress: 100,
                                    isEditing: true, // ✅ REQUIRED
                                }));

                                setProjectDetails(prev => ({
                                    ...prev,
                                    documents: [...prev.documents, ...droppedDocs],
                                }));
                            }}
                        >
                            Drag & drop files here

                        </div>


                        {projectDetails.documents.map((doc, index) => (
                            <div className="taiga-attachment-row">
                                {/* Left: file info */}
                                <div className="taiga-file-info">
                                    <i className="fas fa-paperclip me-2"></i>
                                    <div>
                                        <div className="fw-semibold">{doc.file.name}</div>
                                        <small className="text-muted">
                                            {(doc.file.size / 1024).toFixed(1)} KB
                                        </small>
                                    </div>
                                </div>

                                {/* Middle: description */}
                                <div className="taiga-desc-area">
                                    {doc.isEditing ? (
                                        <>
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="Type a short desc"
                                                value={doc.description}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setProjectDetails(prev => {
                                                        const docs = [...prev.documents];
                                                        docs[index].description = value;
                                                        return { ...prev, documents: docs };
                                                    });
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault(); // 🚫 prevent form submit

                                                        setProjectDetails(prev => {
                                                            const docs = [...prev.documents];
                                                            docs[index].isEditing = false; // ✅ Save on Enter
                                                            return { ...prev, documents: docs };
                                                        });
                                                    }
                                                }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm text-success"
                                                title="Save description"
                                                onClick={() => {
                                                    setProjectDetails(prev => {
                                                        const docs = [...prev.documents];
                                                        docs[index].isEditing = false;
                                                        return { ...prev, documents: docs };
                                                    });
                                                }}
                                            >
                                                <i className="fas fa-save"></i>
                                            </button>

                                        </>
                                    ) : (
                                        <span className="text-muted small">
                                            {doc.description || "No description"}
                                        </span>
                                    )}
                                </div>

                                <div className="taiga-actions">
                                    {!doc.isEditing && (
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm"
                                            title="Edit description"
                                            onClick={() => {
                                                setProjectDetails(prev => {
                                                    const docs = [...prev.documents];
                                                    docs[index].isEditing = true;
                                                    return { ...prev, documents: docs };
                                                });
                                            }}
                                        >
                                            <i className="fas fa-pen"></i>
                                        </button>

                                    )}

                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-danger"
                                        title="Remove attachment"
                                        onClick={() =>
                                            confirmRemoveAttachment(index, doc.file.name)
                                        }
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>


                                </div>
                            </div>

                        ))}
                    </div>



                    <div className="section-header mt-4">Other Details</div>

                    <div className="row g-3 align-items-start">
                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Inquiry Source
                                </label>
                                <Select
                                    options={sourceOptions}
                                    value={
                                        sourceOptions.find(
                                            opt => opt.value === projectDetails.inquirySource?.value
                                        ) || null
                                    }
                                    onChange={(selected) => {
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            inquirySource: selected,
                                        }));
                                        setErrors(prev => ({ ...prev, inquirySource: "" }));
                                    }}
                                    placeholder="Select Inquiry Source *"
                                    classNamePrefix="react-select"
                                    className={errors.inquirySource ? "is-invalid-select" : ""}
                                />

                                {errors.inquirySource && (
                                    <div className="text-danger small">{errors.inquirySource}</div>
                                )}

                            </div>
                        </div>


                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Inquiry Stage *
                                </label>
                                <Select
                                    options={stageOptions}
                                    value={
                                        stageOptions.find(
                                            opt => opt.value === projectDetails.inquiryStage?.value
                                        ) || null
                                    }
                                    onChange={(selected) =>
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            inquiryStage: selected,
                                        }))
                                    }
                                    placeholder="Select Stage *"
                                    classNamePrefix="react-select"
                                    isLoading={loadingStages}
                                    onMenuScrollToBottom={() => {
                                        if (!loadingStages && hasMoreStages) {
                                            fetchStages(stagePage + 1);
                                        }
                                    }}
                                    isDisabled={true}   // ⭐ prevents change

                                />



                                {errors.inquiryStage && (
                                    <div className="text-danger small">{errors.inquiryStage}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Responsible Person *
                                </label>
                                <Select
                                    options={responsibleOptions}
                                    value={responsibleOptions.find(
                                        opt => opt.value === projectDetails.responsiblePerson?.value
                                    ) || null}
                                    onChange={(selected) =>
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            responsiblePerson: selected,
                                        }))
                                    }
                                    placeholder="Select  Person *"
                                    classNamePrefix="react-select"
                                />
                                {errors.responsiblePerson && (
                                    <div className="text-danger small">{errors.responsiblePerson}</div>
                                )}

                            </div>
                        </div>


                        <div className="col-md-3 stage-list">
                            <div className="form-group">
                                <label className="form-label fw-semibold my-3">
                                    Assign To *
                                </label>
                                <Select
                                    options={responsibleOptions}
                                    value={responsibleOptions.find(
                                        opt => opt.value === projectDetails.assignTo?.value
                                    ) || null}
                                    onChange={(selected) =>
                                        setProjectDetails(prev => ({
                                            ...prev,
                                            assignTo: selected,
                                        }))
                                    }
                                    placeholder="Assign To *"
                                    classNamePrefix="react-select"
                                />
                                {errors.assignTo && (
                                    <div className="text-danger small">{errors.assignTo}</div>
                                )}

                            </div>
                        </div>

                        <div className="col-md-3">
                            <label className="form-label fw-semibold my-3">
                                Inquiry Received Date *
                            </label>
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className={`form-control ${errors.inquiryReceivedDate ? "is-invalid" : ""}`}
                                    name="inquiryReceivedDate"
                                    value={projectDetails.inquiryReceivedDate}
                                    onChange={handleInputChange}
                                    placeholder="Inquiry Received Date *"
                                    // max={getTodayDate()}
                                />
                                <label>Inquiry Received Date *</label>
                                {errors.inquiryReceivedDate && (
                                    <div className="text-danger small">{errors.inquiryReceivedDate}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-9">
                            <label className="form-label fw-semibold my-3">
                                Special Note
                            </label>
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    name="specialNote"
                                    value={projectDetails.specialNote}
                                    onChange={handleInputChange}
                                    placeholder="Special Note"
                                />
                                <label>Special Note</label>
                            </div>
                        </div>
                    </div>

                    {/* ================= ACTIONS ================= */}
                    <div className="form-actions mt-4">
                        <button
                            className="btn btn-primary px-4"
                            onClick={handleCreateInquiry}
                        >
                            Create
                        </button>

                        <button
                            className="btn btn-secondary px-4 ms-3"
                            onClick={() => navigate(`/${vertical}/inquiries`)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InquiryCreate;
